import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as ClientDashboardTypes,
  Creators as ClientDashboardActions,
} from '../ducks/ClientDashboard';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getClientTopNumbers() {
  try {
    const { status, data } = yield call(api.get, '/client-dashboard/top-numbers');
    if (status === 200) {
      yield put(
        ClientDashboardActions.getClientTopNumbersSuccess(data.topNumbers)
      );
    } else {
      Sentry.captureMessage('getClientTopNumbers failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });

      yield put(
        ClientDashboardActions.getClientTopNumbersError(
          'Error listing topnumbers'
        )
      );
    }
  } catch(error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(
      ClientDashboardActions.getClientTopNumbersError(
        'Error listing topnumbers'
      )
    );
  }
}

function* getApprovedRecsByYear() {
  try {
    const { status, data } = yield call(
      api.get,
      '/client-dashboard/approved-recs-by-year'
    );
    if (status === 200) {
      yield put(ClientDashboardActions.getApprovedRecsByYearSuccess(data));
    } else {
      Sentry.captureMessage('getApprovedRecsByYear failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });

      yield put(
        ClientDashboardActions.getApprovedRecsByYearError(
          "Error listing approved RECs by year"
        )
      );
    }
  } catch(error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(
      ClientDashboardActions.getApprovedRecsByYearError(
        "Error listing approved RECs by year"
      )
    );
  }
}

function* getAvailableMwhForEmission() {
  try {
    const { status, data } = yield call(
      api.get,
      '/client-dashboard/available-mwh-for-emission'
    );
    if (status === 200) {
      yield put(ClientDashboardActions.getAvailableMwhForEmissionSuccess(data));
    } else {
      Sentry.captureMessage('getAvailableMwhForEmission failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(
        ClientDashboardActions.getAvailableMwhForEmissionError(
          'Error listing available MWH for issuance'
        )
      );
    }
  } catch(error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(
      ClientDashboardActions.getAvailableMwhForEmissionError(
        'Error listing available MWH for issuance'
      )
    );
  }
}

function* getBusinessBySource() {
  try {
    const { status, data } = yield call(
      api.get,
      '/client-dashboard/businesses-by-source'
    );
    if (status === 200) {
      yield put(ClientDashboardActions.getBusinessBySourceSuccess(data));
    } else {
      Sentry.captureMessage('getBusinessBySource failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(
        ClientDashboardActions.getBusinessBySourceError(
          'Error listing projects by energy source'
        )
      );
    }
  } catch(error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(
      ClientDashboardActions.getBusinessBySourceError(
        'Error listing projects by energy source'
      )
    );
  }
}

function* getLastApprovedRecs() {
  try {
    const { status, data } = yield call(
      api.get,
      '/client-dashboard/last-approved-recs'
    );
    if (status === 200) {
      yield put(ClientDashboardActions.getLastApprovedRecsSuccess(data));
    } else {
      Sentry.captureMessage('getLastApprovedRecs failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(
        ClientDashboardActions.getLastApprovedRecsError(
          "Error listing the last approved REC's"
        )
      );
    }
  } catch(error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(
      ClientDashboardActions.getLastApprovedRecsError(
        "Error listing the last approved REC's"
      )
    );
  }
}

function* getClientTopNumbersWatcher() {
  yield takeLatest(
    ClientDashboardTypes.GET_CLIENT_TOP_NUMBERS,
    getClientTopNumbers
  );
}

function* getApprovedRecsByYearWatcher() {
  yield takeLatest(
    ClientDashboardTypes.GET_APPROVED_RECS_BY_YEAR,
    getApprovedRecsByYear
  );
}

function* getAvailableMwhForEmissionWatcher() {
  yield takeLatest(
    ClientDashboardTypes.GET_AVAILABLE_MWH_FOR_EMISSION,
    getAvailableMwhForEmission
  );
}

function* getBusinessBySourceWatcher() {
  yield takeLatest(
    ClientDashboardTypes.GET_BUSINESS_BY_SOURCE,
    getBusinessBySource
  );
}

function* getLastApprovedRecsWatcher() {
  yield takeLatest(
    ClientDashboardTypes.GET_LAST_APPROVED_RECS,
    getLastApprovedRecs
  );
}

export default function* rootSaga() {
  yield all([
    fork(getClientTopNumbersWatcher),
    fork(getApprovedRecsByYearWatcher),
    fork(getAvailableMwhForEmissionWatcher),
    fork(getBusinessBySourceWatcher),
    fork(getLastApprovedRecsWatcher),
  ]);
}
